// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group-item{
    background: transparent;
    border: none;
    color: white;
}

#page-wrap {
  width: 600px;
  margin: 15px auto;
  position: relative;
}

#sidebar {
  top: 310px;
  width: 450px;
  position: fixed;
  right: 35px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpZmUtcHJvamVjdHMuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLHVCQUF1QjtJQUN2QixZQUFZO0lBQ1osWUFBWTtBQUNoQjs7QUFFQTtFQUNFLFlBQVk7RUFDWixpQkFBaUI7RUFDakIsa0JBQWtCO0FBQ3BCOztBQUVBO0VBQ0UsVUFBVTtFQUNWLFlBQVk7RUFDWixlQUFlO0VBQ2YsV0FBVztBQUNiIiwiZmlsZSI6ImxpZmUtcHJvamVjdHMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5saXN0LWdyb3VwLWl0ZW17XG4gICAgYmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7XG4gICAgYm9yZGVyOiBub25lO1xuICAgIGNvbG9yOiB3aGl0ZTtcbn1cblxuI3BhZ2Utd3JhcCB7XG4gIHdpZHRoOiA2MDBweDtcbiAgbWFyZ2luOiAxNXB4IGF1dG87XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbn1cblxuI3NpZGViYXIge1xuICB0b3A6IDMxMHB4O1xuICB3aWR0aDogNDUwcHg7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgcmlnaHQ6IDM1cHg7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/core/components/life-projects/life-projects.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA,gwBAAgwB","sourcesContent":[".list-group-item{\n    background: transparent;\n    border: none;\n    color: white;\n}\n\n#page-wrap {\n  width: 600px;\n  margin: 15px auto;\n  position: relative;\n}\n\n#sidebar {\n  top: 310px;\n  width: 450px;\n  position: fixed;\n  right: 35px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
